import MCommunitySessionDialog from './MCommunitySessionDialog.vue';

export default MCommunitySessionDialog;
export { MCommunitySessionDialog };
